<template>
  <PageViewContainer>
    <v-row>
      <v-col cols="12" class="text-center">
    <span class="text-overline text-uppercase" :style="{color: color}">
      {{ text.pages.userView.title }}
      <v-btn x-small
             @click="showChangePassword"
             color="primary">
        {{ text.buttons.changePassword }}
      </v-btn>
    </span>
        <v-divider :style="{borderColor:color}"/>
        <div class="arrowDown" :style="{borderTop: '6px solid ' + color}"></div>
      </v-col>
      <v-col cols="12" md="4" offset-md="4" class="text-center">
        <v-form
          ref="form"
          v-model="validUserForm"
          lazy-validation
          v-if="customer"
        >
          <v-text-field
            v-model="customer.username"
            :rules="requiredAndLength"
            :counter="100"
            :label="text.fields.username"
            required
            :error-messages="errors.username"
          ></v-text-field>
          <v-text-field
            v-model="customer.email"
            type="email"
            :rules="emailRules"
            :counter="100"
            :label="text.fields.email"
            :error-messages="errors.email"
            required
          ></v-text-field>
          <v-switch
            v-model="customer.agreed_for_newsletter"
            color="primary"
            :label="text.fields.agreedForNewsletter"
          ></v-switch>
          <v-btn @click="confirmCustomer" color="primary">{{ text.buttons.save }}</v-btn>
        </v-form>

        <v-form ref="formPassword" model="validPasswordForm"
                v-if="showPasswordForm">
          <v-text-field
            v-model="password.password"
            :label="$store.state.text.fields.password"
            required
            :rules="requiredAndLength"
            :counter="100"
            class="text-uppercase"
            type="password"
          ></v-text-field>
          <v-text-field
            v-model="password.passwordRepeat"
            :label="$store.state.text.fields.passwordRepeat"
            :rules="passwordRepeatRules"
            required
            :counter="100"
            class="text-uppercase"
            type="password"
          ></v-text-field>
          <v-btn @click="changePassword" color="error" small>{{ text.buttons.save }}</v-btn>
        </v-form>
      </v-col>

      <v-col cols="12" class="text-center">
    <span class="text-overline text-uppercase" :style="{color: color}">
      {{ text.pages.userView.addressList }}
    </span>
        <v-divider :style="{borderColor:color}"/>
        <div class="arrowDown" :style="{borderTop: '6px solid ' + color}"></div>
        <v-col cols="12" md="10" offset-md="1" class="text-center">
          <SimpleTable v-if="customer && customer.address"
                       :headers="addressTableHeaders"
                       :items="customer.address"
                       :default="true"
                       :showActions="true"
                       v-on:editAction="editAction"
                       v-on:deleteAction="deleteAction"
          />
        </v-col>
        <v-btn @click="addAddressForm = !addAddressForm; addressToEdit = null;"
               color="primary" small>
          {{ text.buttons.addAddress }}
        </v-btn>
      </v-col>
      <DialogContainer
        v-if="addAddressForm"
        :open="addAddressForm" v-on:cancel="cancel"
        :title="text.pages.userView.addAddressTitle"
        width="600"
        v-on:confirm="saveAddress">
        <AddressForm v-on:formData="formData" :addressToEdit="addressToEdit"/>
      </DialogContainer>
      <DialogContainer
        :open="openDialog"
        v-on:cancel="openDialog = false"
        v-on:confirm="removeAddress">
        {{ text.common.removeRow }}
      </DialogContainer>
    </v-row>
  </PageViewContainer>
</template>

<script>
import Axios from '@/core/Axios';
import { translations } from '@/lang/translations';
import { state } from '@/store';
import DialogContainer from '@/components/Partials/DialogContainer.vue';
import AddressForm from '@/components/Partials/AddressForm.vue';
import SimpleTable from '@/components/Partials/SimpleTable.vue';
import PageViewContainer from '@/components/Partials/PageViewContainer.vue';

export default {
  name: 'UserView',
  components: {
    PageViewContainer, SimpleTable, AddressForm, DialogContainer,
  },
  data() {
    return {
      axios: new Axios(),
      categoryWithProducts: null,
      color: '#0084cc',
      customer: null,
      validUserForm: true,
      showPasswordForm: false,
      validPasswordForm: true,
      errors: [],
      addAddressForm: false,
      password: {
        password: null,
        passwordRepeat: null,
        changePassword: true,
      },
      passwordRepeatRules: [
        (v) => v === this.user.password || state.text.fields.validation.passwordNotMatch,
      ],
      addressForm: null,
      addressToEdit: null,
      openDialog: false,
    };
  },
  mounted() {
    this.redirectIfNotLogged();
    this.getCustomerDataByUid();
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
    user() {
      return this.$store.state.user;
    },
    requiredAndLength() {
      return this.requiredRules.concat(this.lengthRules);
    },
    requiredRules() {
      return [
        (v) => !!v || this.text.validation.fieldIsRequired,
      ];
    },
    lengthRules() {
      return [
        (v) => (v && v.length <= 100) || `${this.text.validation.maxCharactes}: 100`,
      ];
    },
    emailRules() {
      return [
        (v) => !!v || this.text.validation.fieldIsRequired,
        (v) => /.+@.+\..+/.test(v) || this.text.validation.emailNotValid,
      ];
    },
    addressTableHeaders() {
      return {
        // eslint-disable-next-line @typescript-eslint/camelcase
        first_name: this.text.fields.address.firstName,
        // eslint-disable-next-line @typescript-eslint/camelcase
        last_name: this.text.fields.address.lastName,
        // eslint-disable-next-line @typescript-eslint/camelcase
        address_1: this.text.fields.address.address1,
        // eslint-disable-next-line @typescript-eslint/camelcase
        address_2: this.text.fields.address.address2,
        zip: this.text.fields.address.zip,
        city: this.text.fields.address.city,
        default: this.text.fields.default,
        actions: this.text.fields.actions,
      };
    },
  },
  watch: {
    user() {
      this.redirectIfNotLogged();
      this.getCustomerDataByUid();
    },
  },
  methods: {
    formData(data) {
      this.addressForm = data;
    },
    cancel() {
      this.addAddressForm = false;
    },
    showChangePassword() {
      this.showPasswordForm = !this.showPasswordForm;
    },
    redirectIfNotLogged() {
      if (!this.$store.state.user) {
        this.$router.push('/');
      }
    },
    getCustomerDataByUid() {
      this.axios.makeCall('POST', 'norbit/customer/getcustomer',
        { uid: this.user.uid })
        .then((response) => {
          if (response) {
            this.customer = response;
          }
        })
        .catch(() => {
          this.$store.commit('showSnackbar', {
            type: 'error',
            message:
            this.text.messages.loadDataError,
          });
        });
    },
    confirmCustomer() {
      this.validUserForm = true;
      this.$refs.form.validate();
      if (this.validUserForm) {
        this.updateCustomer(this.customer);
      }
    },
    changePassword() {
      this.validPasswordForm = true;
      this.$refs.formPassword.validate();
      if (this.validPasswordForm) {
        this.updateCustomer(this.password);
      }
    },
    updateCustomer(data) {
      this.axios.makeCall('PUT', `norbit/customer/${this.customer.id}`, data)
        .then((response) => {
          if (response) {
            this.$store.dispatch('showSnackBar', {
              type: 'success',
              message:
              this.text.messages.saveSuccess,
            });
          }
        })
        .catch((error) => {
          this.errors = error.errors;
        });
    },
    saveAddress() {
      if (!this.addressForm.id) {
        this.axios.makeCall('POST', `norbit/customer/${this.customer.id}/addaddress`, this.addressForm)
          .then((response) => {
            if (response) {
              this.addAddressForm = false;
              this.getCustomerDataByUid();
              this.$store.dispatch('showSnackBar', {
                type: 'success',
                message:
                this.text.messages.saveSuccess,
              });
            }
          })
          .catch(() => {
            this.$store.dispatch('showSnackBar', {
              type: 'error',
              message:
              this.text.messages.saveError,
            });
          });
      } else {
        this.axios.makeCall('PUT', `norbit/customer/${this.customer.id}/editaddress`, this.addressForm)
          .then((response) => {
            if (response) {
              this.addAddressForm = false;
              this.getCustomerDataByUid();
              this.$store.dispatch('showSnackBar', {
                type: 'success',
                message:
                this.text.messages.saveSuccess,
              });
            }
          })
          .catch(() => {
            this.$store.dispatch('showSnackBar', {
              type: 'error',
              message:
              this.text.messages.saveError,
            });
          });
      }
      this.addressToEdit = null;
    },
    editAction(addressId) {
      this.addressToEdit = this.customer.address.find((v) => v.id === addressId);
      this.addAddressForm = true;
    },
    deleteAction(addressId) {
      this.addressToEdit = this.customer.address.find((v) => v.id === addressId);
      this.openDialog = true;
    },
    removeAddress() {
      this.openDialog = false;
      this.axios.makeCall('DELETE', `norbit/customer/${this.addressToEdit.id}/removeaddress`)
        .then((response) => {
          if (response) {
            this.getCustomerDataByUid();
            this.$store.dispatch('showSnackBar', {
              type: 'success',
              message:
              this.text.messages.saveSuccess,
            });
            this.addressToEdit = null;
          }
        })
        .catch(() => {
          this.$store.dispatch('showSnackBar', {
            type: 'error',
            message:
            this.text.messages.saveError,
          });
        });
      this.addressToEdit = null;
    },
  },
};
</script>

<style scoped>
.arrowDown {
  width: 0;
  height: 0;
  margin-left: 49.5%;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
}
</style>
